"use client";
import { useEffect } from "react";

const EngatiBot = () => {
  useEffect(() => {
    (function (e, t, a) {
      const c = e.head || e.getElementsByTagName("head")[0];
      const n = e.createElement("script");
      n.async = true;
      n.defer = true;
      n.type = "text/javascript";
      n.src = t + "/static/js/widget.js?config=" + JSON.stringify(a);
      c.appendChild(n);
    })(document, "https://app.engati.com", {
      bot_key: "e99757696be64b11",
     // welcome_msg: false,
      branding_key: "default",
      server: "https://app.engati.com",
      e: "p",
    });
  }, []);

  return null;
};

export default EngatiBot;
